module.exports = __webpack_public_path__ + "img/feiji.ff0b4036.png";